import React, { useEffect } from 'react'
import styled from 'styled-components'

const CookieContainer = styled.div`
  cookie-banner:not(:defined) {
    visibility: hidden;
  }

  /* container styling, e.g. the content container */
  cookie-banner::part(dialog) {
    background-color: white;
    font-size: 1.5rem;
    z-index: 1000;
    padding: 1.5rem;
    border-width: 2px;
    border-style: solid;
    border-color: black;
  }

  /* text content styling, e.g. the <slot> content */
  cookie-banner::part(content) {
    color: black;
    font-size: 1.5rem;
  }

  /* nested elements can be styled directly */
  cookie-banner h2 {
    font-size: 1.75rem;
    margin-bottom: 0.75rem;
    color: black;
  }

  cookie-banner p {
    color: black;

    & a {
      color: ${(props) => props.linkColor || props.buttonColor || 'black'};
    }
  }

  /* button container */
  cookie-banner::part(buttons) {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
  }

  /* <button> elements */
  cookie-banner::part(button) {
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    background-color: ${(props) => props.buttonColor || 'black'};
    color: ${(props) => props.buttonTextColor || 'white'};
    font-weight: 700;
    font-family: inherit;
    font-size: 1rem;
    transition: background-color 0.3s ease;

    &:hover,
    &:focus {
      background-color: ${(props) => props.buttonHoverColor || '#333'};
    }
  }
`

const CookieConsent = ({ privacyUrl, colors, darkText }) => {
  useEffect(() => {
    const script = document.createElement('script')
    script.type = 'module'
    script.src =
      'https://unpkg.com/@walltowall/cookie-banner@1.0.4/dist/cookie-banner.js'
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <CookieContainer
      buttonColor={colors?.buttonColor}
      buttonHoverColor={colors?.buttonHoverColor}
      buttonTextColor={colors?.buttonTextColor}
      linkColor={colors?.linkColor}
    >
      <cookie-banner storage-key="cookie-consent">
        <h2>Privacy Settings</h2>
        <p>
          This website uses cookies to improve your browsing experience and
          analyze site traffic. See our <a href={privacyUrl}>Privacy Policy</a>{' '}
          for more information.
        </p>
      </cookie-banner>
    </CookieContainer>
  )
}

export default CookieConsent
